export class ModuleCV {

    public static all: ModuleCV = new ModuleCV();

    public ADMINISTRATION = 'administration';
    public COORDINATION = 'coordination';
    public SLOT_MONITORING = 'slotMonitoring';
    public INITIAL_COORDINATION = 'initialCoordination';
    public PENDING = 'pending';
    public PORTAL_FILTER = 'portalFilter';

    constructor() {
    }
}
